import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Respuesta de GET funcion-quimica (grupo nutricional en la UI). */
export interface GrupoNutricionalApi {
    id: number;
    funcionEspecificaId: number;
    nombre: string;
    codigo: string;
    estado: string;
}

export interface GrupoNutricionalFiltros {
    id?: number;
    tipoProductoId?: number;
    funcionEspecificaId?: number;
    estado?: string;
}

@Injectable({
    providedIn: 'root',
})
export class GrupoNutricionalService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public getGruposNutricionales(
        filtros: GrupoNutricionalFiltros = {}
    ): Observable<GrupoNutricionalApi[]> {
        if (
            filtros.funcionEspecificaId !== undefined &&
            filtros.funcionEspecificaId !== null
        ) {
            return this.getGruposNutricionalesPorFuncionEspecifica(
                filtros.funcionEspecificaId,
                filtros.estado,
                filtros.tipoProductoId
            );
        }

        let params = new HttpParams();
        if (filtros.id !== undefined) {
            params = params.set('id', String(filtros.id));
        }
        if (filtros.tipoProductoId !== undefined) {
            params = params.set(
                'tipoProductoId',
                String(filtros.tipoProductoId)
            );
        }
        if (filtros.estado !== undefined) {
            params = params.set('estado', filtros.estado);
        }
        return this.http.get<GrupoNutricionalApi[]>(
            `${this._apiUrl}funcion-quimica`,
            { params }
        );
    }

    public getGruposNutricionalesPorFuncionEspecifica(
        funcionEspecificaId: number,
        estado?: string,
        tipoProductoId?: number
    ): Observable<GrupoNutricionalApi[]> {
        let params = new HttpParams();
        if (tipoProductoId !== undefined) {
            params = params.set('tipoProductoId', String(tipoProductoId));
        }
        if (estado !== undefined) {
            params = params.set('estado', estado);
        }
        return this.http.get<GrupoNutricionalApi[]>(
            `${this._apiUrl}funcion-quimica/funcion-especifica/${funcionEspecificaId}`,
            { params }
        );
    }
}
